'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "listStyleReset", "condensed", "variant", "weight"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Text } from "../Text/index.mjs";
import { warnLegacyTypeVariant } from "../../logging.mjs";
import styled from "../../styled-components.mjs";
import { mapLegacyToTextVariant } from "../../utils.mjs";
var TypeListItemElement = styled(Text).withConfig({
  displayName: "TypeListItem__TypeListItemElement",
  componentId: "sc-q1l2mf-0"
})(["display:list-item;padding-block-end:", ";", ";"], function (props) {
  return !props.$condensed && '1em';
}, function (props) {
  return props.$listStyleReset && "list-style-type: none";
});
export var TypeListItem = /*#__PURE__*/React.forwardRef(function TypeListItem(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'li' : _ref$as,
    _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    condensed = _ref.condensed,
    variant = _ref.variant,
    weight = _ref.weight,
    props = _objectWithoutProperties(_ref, _excluded);
  if (variant) warnLegacyTypeVariant('TypeListItem', variant, weight);
  return /*#__PURE__*/React.createElement(TypeListItemElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    variant: variant && mapLegacyToTextVariant(variant, weight),
    $condensed: condensed,
    $listStyleReset: listStyleReset,
    "data-encore-id": ENCORE_DATA_IDS.TypeListItem
  }));
});